import { create } from 'zustand';

interface MilestoneToastState {
  pending: { label: string; minutes: number } | null;
  show: (label: string, minutes: number) => void;
  dismiss: () => void;
}

export const useMilestoneToastStore = create<MilestoneToastState>((set) => ({
  pending: null,
  show: (label, minutes) => set({ pending: { label, minutes } }),
  dismiss: () => set({ pending: null }),
}));
